import React from "react";
import { EditableTable, createQuickRenderer } from "../../common";
import { useKycDirectorsTable, type IKycDirectorsTableProps } from "./useKycDirectorsTable";

export const KycDirectorsTable: React.FC<IKycDirectorsTableProps> = props => {
  const { directors, directorColumns, handleChange, crossIntl } = useKycDirectorsTable(
    props,
    createQuickRenderer,
  );
  return (
    <EditableTable
      value={directors}
      onChange={handleChange}
      columns={directorColumns}
      title={crossIntl["shareholder.table.title"]}
      addButtonText={crossIntl["shareholder.button.add"]}
      minRows={2}
    />
  );
};
